import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { X, Moon } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = '/api';
const C = { bg: '#FDFBF7', text: '#1A1A18', textSec: '#6A6560', muted: '#9A9590', accent: '#C67A5C', border: '#E8E3DB', cream: '#F5F0E8', card: '#FFFFFF', purple: '#8B7EC8' };

export const SleepLogModal = ({ onClose, onSaved }) => {
  const { authHeaders } = useAuth();
  const [hours, setHours] = useState('');
  const [quality, setQuality] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!hours) return;
    setSaving(true);
    try {
      const qualityMap = { poor: 1, fair: 2, good: 3, great: 4 };
      await axios.post(`${API}/sleep/log`, {
        sleep_hours: parseFloat(hours),
        quality: qualityMap[quality] || 2,
        date: new Date().toISOString().split('T')[0],
      }, authHeaders());
      onSaved({ quality: quality || 'fair', hours: parseFloat(hours) });
      onClose();
    } catch {}
    setSaving(false);
  };

  return ReactDOM.createPortal(
    <div
      data-testid="sleep-modal-backdrop"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px' }}
    >
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(4px)' }} />
      <div onClick={e => e.stopPropagation()} style={{
        position: 'relative', width: '100%', maxWidth: 380,
        background: C.bg, borderRadius: 24, border: `1px solid ${C.border}`,
        boxShadow: '0 16px 48px rgba(0,0,0,0.15)', overflow: 'hidden',
      }}>
        <div style={{ padding: '24px 22px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Moon style={{ width: 20, height: 20, color: C.purple }} />
              <p style={{ fontSize: 20, fontWeight: 400, margin: 0, color: C.text, fontFamily: 'var(--font-serif)' }}>Log sleep</p>
            </div>
            <button data-testid="sleep-modal-close" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
              <X className="w-4 h-4" style={{ color: '#9A9590' }} />
            </button>
          </div>
          <p style={{ fontSize: 13, margin: '0 0 10px', color: C.textSec, fontFamily: 'var(--font-sans)' }}>How long did you sleep?</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <input data-testid="dash-sleep-hours" type="number" step="0.5" min="0" max="24" value={hours} onChange={e => setHours(e.target.value)} placeholder="7.5" style={{
              width: 80, padding: '10px 12px', borderRadius: 12, border: `1px solid ${C.border}`,
              background: C.card, fontSize: 16, fontFamily: 'var(--font-sans)', color: C.text, textAlign: 'center', outline: 'none',
            }} />
            <span style={{ fontSize: 14, color: '#9A9590', fontFamily: 'var(--font-sans)' }}>hours</span>
          </div>
          <p style={{ fontSize: 13, margin: '0 0 10px', color: C.textSec, fontFamily: 'var(--font-sans)' }}>How was the quality?</p>
          <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
            {['poor', 'fair', 'good', 'great'].map(q => (
              <button key={q} data-testid={`sleep-quality-${q}`} onClick={() => setQuality(q)} style={{
                flex: 1, padding: '8px 4px', borderRadius: 20, border: 'none', cursor: 'pointer',
                background: quality === q ? C.text : C.cream,
                color: quality === q ? '#FDFBF7' : C.textSec,
                fontSize: 12, fontWeight: 500, fontFamily: 'var(--font-sans)', textTransform: 'capitalize',
              }}>{q}</button>
            ))}
          </div>
          <button data-testid="dash-sleep-submit" onClick={handleSubmit} disabled={saving || !hours} style={{
            width: '100%', padding: '12px', borderRadius: 28, border: 'none',
            background: hours ? C.text : C.border, color: hours ? '#FDFBF7' : '#9A9590',
            fontSize: 14, fontWeight: 500, cursor: hours ? 'pointer' : 'default',
            fontFamily: 'var(--font-sans)', opacity: saving ? 0.7 : 1,
          }}>{saving ? 'Saving...' : 'Log sleep'}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
